window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat).replace('.00', ''));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat).replace('.00', ''));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


if($('body').hasClass('template-product')){
  CartJS.init(cartjson);
}


// New Products Slider
if ( $('.product-slider-main').length ) {  
  var $slider = $('.product-slider-main')
  .on('init', function(slick) {
    //console.log('fade in');
    $('.product-slider-main').fadeIn(1000);
  })
  .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    lazyLoad: 'ondemand',
    asNavFor: '.product-slider-thumbs',
    adaptiveHeight: false
  })
  /*.on('lazyLoaded', function(event, slick, image, imageSource) {
    slick.resize();
  });*/
  
  var $slider2 = $('.product-slider-thumbs')
  .on('init', function(slick) {
    $('.product-slider-thumbs').fadeIn(1000);
  })
  .slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    asNavFor: '.product-slider-main',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });
  
  $('.product-slider-thumbs .slick-slide').removeClass('slick-active');
  
  $('.product-slider-thumbs .slick-slide').eq(0).addClass('slick-active');
  
  $('.product-slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.product-slider-thumbs .slick-slide').removeClass('slick-active');
    $('.product-slider-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
  });

  $(document).ready(function(){
    initZoom()
  });
  
  function initZoom() {
    //$('.product-slider-main .slide').each(function(){
      console.log($('.slick-active .image-zoom').find('img').attr('data-zoom'));
      $('.slick-active .image-zoom').zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    //}); 
  }
  
  $('.product-slider-main').on('afterChange', function() {
    $('.image-zoom').trigger('zoom.destroy');
    initZoom()
  });
    
}


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Mobile menu
  $('.mobile-menu ul.nav-menu > li > a:contains("Ready to Ship"), ul.site-nav__megamenu-item a:contains("Ready to Ship")').addClass('rts');
  $('.mobile-menu a:contains("Get Samples"), .mobile-menu a:contains("Shop All Tile"), .mobile-menu a:contains("By Space"), .mobile-menu a:contains("By Vibe"), .mobile-menu a:contains("Inspiration") + ul a:contains("Color Blends"), .mobile-menu a:contains("Inspiration") + ul a:contains("Custom Design Gallery"), .mobile-menu a:contains("Inspiration") + ul a:contains("Find Your Style Quiz"), .mobile-menu a:contains("Inspiration") + ul a:contains("Color Palette"), .mobile-menu a:contains("Inspiration") + ul > li > a:contains("Lookbook"), .mobile-menu a:contains("All Shapes")').addClass('strong');
  $('ul.site-nav__megamenu-item a:contains("Shop All Tile")').addClass('strong');
  
  $('.trigger-secondary').click(function(){ 
    $(this).next().fadeIn();
    $(this).closest('.nav-menu').addClass('secondary-open');
  });
  $('.close-secondary').click(function(){
    $(this).closest('.secondary-links').fadeOut();
    $(this).closest('.nav-menu').removeClass('secondary-open');
  });
  /*$('.trigger-tertiary').click(function(e){
    e.preventDefault();
    $(this).parent('li').toggleClass('active');
  });*/
  $('.trigger-tertiary').click(function(){
    $(this).next().fadeIn();
    $(this).closest('.secondary-links').addClass('tertiary-open');
  });
  $('.close-tertiary').click(function(){
    $(this).closest('.tertiary-links').fadeOut();
    $(this).closest('.secondary-links').removeClass('tertiary-open');
  });
  $('.mobile-menu-trigger').click(function(){
    $('.mobile-menu').addClass('open');
    $('body').css('overflow-y','hidden');
  });
  $('.mobile-menu .fa-close').click(function(){
    $('.mobile-menu').removeClass('open');
    $('body').css('overflow','');
  });
  // Desktop menu classes
  

  $('.search-link').click(function(e){
    e.preventDefault();
    $('#search-box').slideToggle();
    return false;
  });
  $('.top-elements button').click(function(e){
    if( !$(this).parent().find('input').val().length ){
      e.preventDefault()
      $('#search-box').slideToggle();
      return false;
    }
  });
  $('#search-box #x').click(function(e){
    e.preventDefault();
    $('#search-box').slideToggle();
    return false;
  });

  // Calculator
  $('.qty-text a, .calculator-trigger').each(function(){
    $(this).attr('data-fancybox', '').attr('data-src', '#calculator-trigger').attr('data-options', '{"touch" : false}').prop('href', 'javascript:;');
  });

  // Sample Add To Cart
  $('.sample-trigger').click(function(){
    $('.cart-loading').show();

    var properties = {};

    // Check if the textarea exists and has a value
    if ($('#product-note').length > 0) {
      var noteValue = $('#product-note').val();
      if (noteValue) {
          properties['Product Note'] = noteValue;
      }
    }

    CartJS.removeItemById($(this).data('id'));
    CartJS.addItem($(this).attr('data-id'), 1, properties,
    {
      "success": function(data, textStatus, jqXHR) {
        $('.loading').hide();
        var currentCart = parseInt($('.cart-text').text());
        var updatedCart = currentCart + parseInt(1);
        $('.cart-text').text(updatedCart);
        $('.sample-confirmation').show();
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        $('.loading').hide();
        // $form.find('.confirmation-message span.message').text('Error: ' + errorThrown + '!').closest('.confirmation-message').addClass('visible');
      }
    });
  });
  
  

  // Description Expand
  if($('.product-description.expand').length){
    $('.product-description.expand .flex').click(function(){
      $(this).parent().toggleClass('expanded');  
    });
  }
  /*if($('.product-description').length){
    $('.product-description:not(.no-more) .desc p:first-child').append(' <a class="expand">More...</a>');
    $('.product-description .desc a.expand').click(function(){
      $('.product-description .desc').addClass('expand');  
    });
  }*/
  
  
  
  // Full-width sliders on About/Custom page
  $('.elves-slider, .gallery-slider, .blog-slider-wrap').slick({
  //$('.gallery-slider').slick({
    centerMode: true,
    centerPadding: '25%',
    slidesToShow: 1,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          centerPadding: '21%'
        }
      },
      {
        breakpoint: 1076,
        settings: {
          centerPadding: '17%'
        }
      },
      {
        breakpoint: 921,
        settings: {
          centerMode: false
        }
      }
    ]
  });

  $(window).load(function () {
    var top = $('.gallery-image').height() / 2;
    $('.slider-holder:not(.sig) .arrow-left, .slider-holder:not(.sig) .arrow-right').css('top', top);
  });

  $(window).resize(function () {
    var top = $('.gallery-image').height() / 2;
    $('.slider-holder:not(.sig) .arrow-left, .slider-holder:not(.sig) .arrow-right').css('top', top);  
  });

  $('.arrow-left').click(function () {
    $('.elves-slider, .blog-slider-wrap').slick('slickPrev');
  });
  $('.arrow-right').click(function () {
    $('.elves-slider, .blog-slider-wrap').slick('slickNext');
  });
  $('.gallery-slider + .arrow-left').click(function () {
    $('.gallery-slider').slick('slickPrev');
  });
  $('.gallery-slider + .arrow-left + .arrow-right').click(function () {
    $('.gallery-slider').slick('slickNext');
  });
  $('.blends-slider + .arrow-left').click(function () {
    $('.blends-slider').slick('slickPrev');
  });
  $('.blends-slider + .arrow-left + .arrow-right').click(function () {
    $('.blends-slider').slick('slickNext');
  });
  $('.samples-slider, .kits-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 675,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  $('.samples-slider:not(.kits-slider) + .arrow-left').click(function () {
    $('.samples-slider').slick('slickPrev');
  });
  $('.samples-slider:not(.kits-slider) + .arrow-left + .arrow-right').click(function () {
    $('.samples-slider').slick('slickNext');
  });
  $('.kits-slider + .arrow-left').click(function () {
    $('.kits-slider').slick('slickPrev');
  });
  $('.kits-slider + .arrow-left + .arrow-right').click(function () {
    $('.kits-slider').slick('slickNext');
  });

  // FAQ title positioning
  if($(window).width() <= 800){
    $('body.faq h1').appendTo('.mobile-heading');
  }

  // FAQ Switching
  $('.qa h3').click(function(){
    $('.qa').not($(this).closest('.qa')).removeClass('open').find('.answer').slideUp();
    if($(this).closest('.qa').hasClass('open')){
      $(this).closest('.qa').removeClass('open').find('.answer').slideUp();
    } else {
      $(this).closest('.qa').addClass('open').find('.answer').slideDown();
    }
  });

  // Consultation Form Select Box
  //$('#consultation select').selectric();

  // Custom Tile Gallery
  // init Masonry
  var $grid = $('.tile-gallery').masonry({
    itemSelector: '.grid-item'
  });
  // layout Masonry after each image loads
  $grid.imagesLoaded().progress(function () {
    $grid.masonry('layout');
  });

  galleryPopup();
});

function galleryPopup(){
  $(".learn-more").click(function() {
    var $title = $(this).closest('.grid-item').find('.data-title');
    var $desc = $(this).closest('.grid-item').find('.data-desc');
    var $img = $(this).prev().prop('src');
    $.fancybox.open({
      src: '#gallery-popup',
      type: 'inline',
      opts: {
        beforeLoad: function () {
          $('.popup-content img').prop('src', $img);
          $title.clone().appendTo('.popup-title');
          $desc.clone().appendTo('.popup-desc');
        },
        afterClose: function(){
          $('.popup-title, .popup-desc').empty();
        }
      }
    });
  });
  $(document).on('afterClose.fb', function (e, instance, slide) {
  });
}

$(document).on('click', 'a[href^="#"]', function (event) {
  event.preventDefault();
  $('html, body').animate({
    scrollTop: $($.attr(this, 'href')).offset().top - 40
  }, 500);
});

// FAQ title positioning on resize
$(window).resize(function(){
  if($(window).width() > 800) {
    $('body.faq h1').appendTo('.desktop-heading');
  } else {
    $('body.faq h1').appendTo('.mobile-heading');
  }
});



// Share count
$(window).load(function(){
  $('.article-sharing').each(function () {
    var count = 0;
    $(this).find('.count').each(function () {
      var val = $(this).text() || 0;
      console.log(val);
      count += parseInt(val);
    });
    $(this).find('.share-counts span').text(count);
  });
});


// Image changing & zooming
resetZoom = function(new_image, new_image_zoom){
  $('img[data-product-featured-image]')
  .prop('src', new_image)
  .attr('data-zoom', new_image_zoom)
  .next()
  .prop('src', new_image_zoom);
}

// Color tooltips
tippy('.color', {
  arrow: true,
  arrowTransform: 'scaleX(1.5)',
  theme: 'custom'
});

// Calculator

// Add Area
$('.add-area').click(function(){
  var lastArea = $('.area:last-of-type');
  lastArea.clone(true).addClass('cloned').insertAfter(lastArea);
  $('.cloned').find('input').each(function(){
    $(this).prop('value','');
  });
  $('.cloned').removeClass('cloned');
  if($('.area').length == 26){
    $('.add-area').hide();
  }
  recalculateLetters();
});

// Remove Area
$('.remove').click(function(){
  $(this).closest('.area').remove();
  if($('.area').length < 26){
    $('.add-area').show();
  }
  recalculateLetters();
});

// Recalculate Letters
recalculateLetters = function(){
  var letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  $('.area').each(function(i){
    $(this).find('.label span').text('Area ' + letters[i]);
  });
}

// Calculate quantity required
$('.calculate').click(function(){
  var overage_amount = document.querySelector("[data-calculator-overage-amount]:checked");

  var total_area = 0;
  $('.calculator-section .row.area').each(function(){
    var width = $(this).find('.width').val() || 1;
    var height = $(this).find('.height').val() || 1;
    var area = width * height;
    total_area += area * 0.0069444;
  });

  var total_area_plus_overage = total_area;

  if (overage_amount) {
    total_area_plus_overage = total_area + ((total_area_plus_overage / 100) * +(overage_amount.value));
  }

  $('.total')
    .text(Math.ceil(total_area_plus_overage))
    .attr("data-original", Math.ceil(total_area));
});

// Use calculated amount
$('.use-this-amount').click(function(){
  $('#Quantity').val($('.qty-total .total').text());
  $('#addWaste').prop('checked', false);
  $('.add-waste').removeAttr('data-added-waste');
  parent.$.fancybox.close();
});

// Add % for waste
$('#addWaste').change(function(){
  var label = $(this).next();
  if($(this).prop('checked') == true){
    waste = Math.ceil($('#Quantity').val() * label.data('waste'));
    label.attr('data-added-waste', waste);
    qty = parseInt($('#Quantity').val()) + parseInt(waste);
    $('#Quantity').val(qty);
    added_waste = 0;
  } else {
    added_waste = label.attr('data-added-waste');
    reduced_qty = $('#Quantity').val() - added_waste;
    $('#Quantity').val(reduced_qty);
    label.removeAttr('data-added-waste');
    added_wate = undefined;
  }
});

// Overages
(function() {
  var add_overage = document.querySelector("[data-calculator-add-overage]");

  if (!add_overage) {
    return;
  }

  var overage_amounts = document.querySelector("[data-calculator-overage-amounts]");

  var overage_amount = document.querySelectorAll("[data-calculator-overage-amount]");

  add_overage.addEventListener("change", function(event) {
    toggle_overage_amounts();
  });

  overage_amount.forEach(function(overage_amount_element) {
    overage_amount_element.addEventListener("change", function(event) {
      $(".calculate").click();
    });
  });

  function toggle_overage_amounts() {
    var is_hidden = getComputedStyle(overage_amounts).display == "none";

    var style_display = is_hidden ? "block" : "none";

    if (!is_hidden) {
      overage_amount.forEach(function(overage_amount_element) {
        overage_amount_element.checked = false;
      });
    }

    overage_amounts.style.display = style_display;

    overage_amount[0].checked = is_hidden ? true : false;

    trigger_event(overage_amount[0], "change");
  };

  function trigger_event(element, event_name) {
    var event = document.createEvent("HTMLEvents");
    event.initEvent(event_name, false, true);
    element.dispatchEvent(event);
  };
})();

// Quantity change --> Uncheck Add % for waste
$("#Quantity").bind('keyup input', function(){
  $('#addWaste').prop('checked', false);
  $('.add-waste').removeAttr('data-added-waste');
});

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

function loadOptions() {
  //console.log('{{ product.handle }}');
  scrollNode = $('#more').last();
  scrollURL = $('#more p a').last().attr("href");
  if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: scrollURL,
      beforeSend: function () {
        // scrollNode.clone().empty().insertAfter(scrollNode).append('<img src=\"{{ "loading.gif" | asset_url }}\" />');
        // scrollNode.hide();
      },
      success: function (data) {
        // remove loading feedback
        // scrollNode.next().remove();
        var filteredData = $(data).find(".product-listing");
        console.log(filteredData);
        filteredData.insertAfter($(".color-selection li:last-child"));
      },
      dataType: "html"
    });
  }
}

if($('body').hasClass('template-product')) {
  $(window).load(function() {
    loadOptions();
  });
}

/*$(document).ready(function() {
  var $hoveredDiv = $('.colors-new .color .panel');
  if ($hoveredDiv.length) {
    function handleMouseLeave() {
      console.log('exit'); 
      $hoveredDiv.addClass('hovered');
      setTimeout(function() {
        $hoveredDiv.removeClass('hovered');
      }, 2000);
    }
    $hoveredDiv.mouseleave(handleMouseLeave);
  }
});*/

/* SV 23 Feb 18 */
/*if (location.pathname.indexOf('color-palette') > -1) {
  (function($) {
    var selectors = {
      img: 'td img',
      popup_products: '#popup-products',
      popup_noproducts: '#popup-no-products'
    };
    var popup_type = selectors.popup_noproducts;

    // Load All products
    var products = [];
    var productsURL = '/collections/best-sellers/products.json?limit=1000';
    $.getJSON(productsURL, function(data) {
      products = data.products || [];
      //console.log(products);

      // If direct link with color name used
      if (location.hash.length) {
        setTimeout(function() {
          $('a.fancybox[href*="' + location.hash + '"]').trigger('click');
        }, 100);
      }
    });

    $(function() {
      // Wrap each img with a link with class fancybox
      $(selectors.img).each(function() {
        var color = $(this).attr('alt').split('Color Chip ')[1];
        console.log(color);
        $(this).wrap('<a href="#'+ color.replace(/ /g, '-') +'" class="fancybox color" data-color="' + color + '"></a>');
      });

      // Open color palette popup
      $('a.fancybox').on('click', function(e) {
        var colorName = $(this).data('color');
        var colorImg = $(this).find('img').attr('src');

        //e.preventDefault();

        addPopupContent({
          colorName: colorName,
          colorImg: colorImg,
          onComplete: function() {
            //console.log(popup_type);
            $.fancybox.open({
              src  : popup_type,
              type : 'inline',
              opts : {
                beforeLoad: function() {},
                afterShow : function(instance, current) {}
              }
            });
          }
        });
      });

      function addPopupContent(options) {
        var colorName = options.colorName,
            colorImg = options.colorImg;

        //console.log(options);

        // Assign products
        var filterProductsByColorName = [];
        if (products && products.length) {
          filterProductsByColorName = _.filter(products, function(product) {
            var tags = product.tags.join(',').toLowerCase();
            var title = product.title.toLowerCase();
            return tags.indexOf(colorName.toLowerCase()) > -1 || title.indexOf(colorName.toLowerCase()) > -1;
          });
          //console.log(filterProductsByColorName);
        }

        if (filterProductsByColorName.length) {
          popup_type = selectors.popup_products;

          $('.products', popup_type).html('');
          _.each(filterProductsByColorName, function(product, index) {
            if (index < 6) {
              $('.products', popup_type).append('<a href="/products/' + product.handle + '">' + product.title + '</a>');
            }
          });
        }
        else {
          popup_type = selectors.popup_noproducts;
        }

        $('.color-name', popup_type).html('<h2>' + colorName + '</h2>');
        $('.left .img', popup_type).html('<img src="' + colorImg + '" />');

        options.onComplete();
      }
    });
  })(jQuery);
}*/  
/* END - SV 23 Feb 18 */

// Global events

var Events = new EventEmitter();

// Load more

(function module_load_more() {
  function Self(element, events, options, module) {
    module.options.active_limit = module.options.limit;
  };

  function StyleTag(element, events, options, module) {
    update();

    events.on("paginationbutton:click", function() {
      module.options.active_limit += module.options.limit;
      update();
    });

    function update() {
      var html = [
        module.options.item_selector + ":not(:nth-child(-n+" + module.options.active_limit + ")) {",
          "display: none;",
        "}"
      ].join("");

      element.innerHTML = html;
    };
  };

  function Pagination(element, events, options, module) {
    update();

    events.on("paginationbutton:click", update);

    function update() {
      if (module.options.active_limit >= module.options.items_size) {
        element.style.display = "none";
      }
    };
  };

  function PaginationButton(element, events, options, module) {
    element.addEventListener("click", function() {
      events.trigger("paginationbutton:click");
    });
  };

  function LoadMore(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      style_tag: element.querySelectorAll("[data-ref-style-tag]"),
      pagination: element.querySelectorAll("[data-ref-pagination]"),
      pagination_button: element.querySelectorAll("[data-ref-pagination-button]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.style_tag.forEach(function(element) {
      var options = element.getAttribute("data-ref-style-tag");
          options = JSON.parse(options || "{}");

      StyleTag(element, events, options, module);
    });

    refs.pagination.forEach(function(element) {
      var options = element.getAttribute("data-ref-pagination");
          options = JSON.parse(options || "{}");

      Pagination(element, events, options, module);
    });

    refs.pagination_button.forEach(function(element) {
      var options = element.getAttribute("data-ref-pagination-button");
          options = JSON.parse(options || "{}");

      PaginationButton(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll("[data-module-load-more]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-load-more");
        options = JSON.parse(options || "{}");

    LoadMore(element, options);
  });
})();

// Modal gallery

(function module_modal_gallery() {
  function Self(element, events, options, module) {
    Events.on("modalgallerynav:previous:click", function() {
      $.fancybox.getInstance().previous();
    });

    Events.on("modalgallerynav:next:click", function() {
      $.fancybox.getInstance().next();
    });
  };

  function Trigger(element, events, options, module) {
    element.addEventListener("click", function(event) {
      event.preventDefault();
      open();
    });

    events.on("url:trigger:" + options.id, open);

    function open() {
      var items = module.options.urls.map(function(url) {
        return {
          src: url + "?view=modal-gallery",
          type: "ajax",
          opts: {
            infobar: false,
            touch: false,
            afterShow: function(instance, slide) {
              Events.trigger("modalgallery:trigger:open", [module.options.handles[slide.index]]);
              events.trigger("trigger:open", [module.options.handles[slide.index]]);
              // Pin Buttons
              $('.article-modal-gallery-content img').each(function() {
                if ( !$(this).parent().hasClass('img-wrap') ) {
                  $(this).wrap('<div class="img-wrap"></div>');
                  var $url = window.location.href;
				  var $img = $(this).attr('src');
                  var $title = $('.article-modal-gallery-title').text();
                  var $pin = 'http://www.pinterest.com/pin/create/button/?url=' + $url + '&media=' + $img + '&description=' + $title;
                  $(this).parent('.img-wrap').append('<a href="' + $pin + '" target="blank"><div class="rapi-button rapi-icon--1 rapi-size--slim rapi-type--basic"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 18"><path d="M16.853,6.345 C17.632,6.345 18.38,5.702 18.51,4.909 C18.664,4.138 18.135,3.494 17.357,3.494 C16.578,3.494 15.83,4.138 15.698,4.909 C15.546,5.702 16.053,6.345 16.853,6.345 Z M7.458,0 C2.5,0 0,3.522 0,6.459 C0,8.237 0.68,9.819 2.137,10.409 C2.376,10.505 2.59,10.412 2.66,10.15 C2.708,9.969 2.822,9.511 2.873,9.32 C2.943,9.061 2.916,8.97 2.723,8.744 C2.302,8.253 2.034,7.617 2.034,6.716 C2.034,4.104 4.007,1.765 7.172,1.765 C9.975,1.765 11.514,3.461 11.514,5.726 C11.514,8.708 10.183,11.18 8.206,11.18 C7.114,11.18 6.297,10.329 6.559,9.233 C6.872,7.922 7.48,6.509 7.48,5.564 C7.48,4.717 7.022,4.011 6.072,4.011 C4.956,4.011 4.06,5.155 4.06,6.687 C4.06,7.663 4.393,8.323 4.393,8.323 C4.393,8.323 3.251,13.117 3.051,13.957 C2.652,15.629 2.991,17.679 3.019,17.886 C3.036,18.009 3.195,18.038 3.267,17.946 C3.37,17.812 4.7,16.187 5.151,14.562 C5.279,14.102 5.885,11.72 5.885,11.72 C6.248,12.406 7.308,13.009 8.435,13.009 C11.79,13.009 14.066,9.979 14.066,5.923 C14.066,2.857 11.444,0 7.458,0 Z M26.896,14.189 C26.348,14.189 26.117,13.915 26.117,13.328 C26.117,12.404 27.035,10.091 27.035,9.041 C27.035,7.638 26.276,6.826 24.72,6.826 C23.739,6.826 22.722,7.453 22.291,8.003 C22.291,8.003 22.422,7.553 22.467,7.38 C22.515,7.196 22.415,6.884 22.173,6.884 L20.651,6.884 C20.328,6.884 20.238,7.055 20.191,7.244 C20.172,7.32 19.624,9.584 19.098,11.632 C18.738,13.034 17.863,14.205 16.928,14.205 C16.447,14.205 16.233,13.906 16.233,13.399 C16.233,12.959 16.519,11.877 16.86,10.534 C17.276,8.898 17.642,7.551 17.681,7.394 C17.732,7.192 17.642,7.017 17.379,7.017 L15.849,7.017 C15.572,7.017 15.473,7.161 15.414,7.361 C15.414,7.361 14.983,8.977 14.527,10.775 C14.196,12.079 13.83,13.409 13.83,14.034 C13.83,15.148 14.336,15.944 15.724,15.944 C16.796,15.944 17.644,15.45 18.292,14.764 C18.197,15.135 18.136,15.414 18.13,15.439 C18.074,15.65 18.142,15.838 18.394,15.838 L19.961,15.838 C20.233,15.838 20.337,15.73 20.394,15.494 C20.449,15.269 21.619,10.667 21.619,10.667 C21.928,9.443 22.692,8.632 23.768,8.632 C24.279,8.632 24.72,8.967 24.669,9.618 C24.612,10.333 23.741,12.903 23.741,14.031 C23.741,14.884 24.06,15.945 25.683,15.945 C26.789,15.945 27.603,15.464 28.195,14.786 L27.489,13.941 C27.311,14.094 27.114,14.189 26.896,14.189 Z M41.701,6.873 L40.134,6.873 C40.134,6.873 40.856,4.109 40.873,4.035 C40.942,3.745 40.698,3.578 40.441,3.631 C40.441,3.631 39.23,3.866 39.005,3.913 C38.779,3.958 38.604,4.081 38.522,4.403 C38.512,4.445 37.88,6.873 37.88,6.873 L36.622,6.873 C36.385,6.873 36.245,6.968 36.192,7.188 C36.115,7.504 35.975,8.145 35.936,8.297 C35.885,8.494 36,8.644 36.222,8.644 L37.457,8.644 C37.448,8.677 37.064,10.125 36.725,11.521 L36.724,11.516 C36.72,11.532 36.716,11.546 36.712,11.562 L36.712,11.556 C36.712,11.556 36.708,11.571 36.702,11.598 C36.324,12.968 35.118,14.209 34.201,14.209 C33.721,14.209 33.506,13.909 33.506,13.402 C33.506,12.963 33.792,11.88 34.134,10.537 C34.549,8.901 34.915,7.555 34.955,7.397 C35.006,7.196 34.915,7.02 34.652,7.02 L33.122,7.02 C32.845,7.02 32.746,7.164 32.687,7.364 C32.687,7.364 32.257,8.98 31.8,10.778 C31.469,12.083 31.103,13.412 31.103,14.037 C31.103,15.151 31.609,15.948 32.997,15.948 C34.07,15.948 35.136,15.453 35.783,14.767 C35.783,14.767 36.011,14.521 36.23,14.229 C36.241,14.581 36.324,14.837 36.411,15.018 C36.458,15.119 36.515,15.215 36.581,15.303 C36.582,15.304 36.583,15.306 36.585,15.308 L36.585,15.308 C36.891,15.713 37.398,15.962 38.151,15.962 C39.894,15.962 40.944,14.938 41.562,13.909 L40.704,13.239 C40.333,13.774 39.839,14.175 39.324,14.175 C38.846,14.175 38.579,13.878 38.579,13.372 C38.579,12.935 38.889,11.868 39.229,10.53 C39.344,10.083 39.516,9.401 39.708,8.644 L41.302,8.644 C41.539,8.644 41.678,8.549 41.732,8.329 C41.808,8.012 41.948,7.372 41.988,7.221 C42.039,7.023 41.923,6.873 41.701,6.873 Z M34.126,6.348 C34.905,6.348 35.653,5.706 35.783,4.912 C35.937,4.141 35.409,3.498 34.63,3.498 C33.851,3.498 33.103,4.141 32.971,4.912 C32.819,5.706 33.326,6.348 34.126,6.348 Z"></path></svg></div></a>');
                }
              });
            },
            afterClose: function() {
              events.trigger("trigger:close");
            }
          }
        }
      });

      $.fancybox.open(items, {}, options.index);
    };
  };

  function Url(events, module) {
    var url_query = simpleQueryString.parse(location.search);

    if (url_query["modal-gallery"]) {
      events.trigger("url:trigger:" + url_query["modal-gallery"]);
    }

    events
      .on("trigger:open", update)
      .on("trigger:close", update);

    function update(id) {
      var url_query = simpleQueryString.parse(location.search);
      var url = window.location.pathname;

      url_query = Object.assign(url_query, { "modal-gallery": id });

      if (!id) {
        delete url_query["modal-gallery"];
      }

      url_query = Object.keys(url_query).length ? "?" + simpleQueryString.stringify(url_query) : "";
      url = url + url_query;

      window.history.replaceState(null, null, url);
    };
  };

  function ModalGallery(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      trigger: element.querySelectorAll("[data-ref-trigger]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.trigger.forEach(function(element) {
      var options = element.getAttribute("data-ref-trigger");
          options = JSON.parse(options || "{}");

      Trigger(element, events, options, module);
    });

    Url(events, module);
  };

  var elements = document.querySelectorAll("[data-module-modal-gallery]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-modal-gallery");
        options = JSON.parse(options || "{}");

    ModalGallery(element, options);
  });
})();

// Modal gallery nav

(function module_page_modal_nav() {
  function Self(element, events, options, module) {};

  function Previous(element, events, options, module) {
    var is_start = $.fancybox.getInstance().currIndex == 0;

    element.classList.remove("is-disabled");

    if (is_start) {
      element.classList.add("is-disabled");
    }

    element.addEventListener("click", function() {
      Events.trigger("modalgallerynav:previous:click");
    });
  };

  function Next(element, events, options, module) {
    var group_length = $.fancybox.getInstance().group.length
    var is_end = $.fancybox.getInstance().currIndex == (group_length - 1);

    element.classList.remove("is-disabled");

    if (is_end) {
      element.classList.add("is-disabled");
    }

    element.addEventListener("click", function() {
      Events.trigger("modalgallerynav:next:click");
    });
  };

  function ModalGalleryNav(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      previous: element.querySelectorAll("[data-ref-previous]"),
      next: element.querySelectorAll("[data-ref-next]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.previous.forEach(function(element) {
      var options = element.getAttribute("data-ref-previous");
          options = JSON.parse(options || "{}");

      Previous(element, events, options, module);
    });

    refs.next.forEach(function(element) {
      var options = element.getAttribute("data-ref-next");
          options = JSON.parse(options || "{}");

      Next(element, events, options, module);
    });
  };

   Events.on("modalgallery:trigger:open", function() {
    var elements = document.querySelectorAll("[data-module-modal-gallery-nav]");

    elements.forEach(function(element) {
      var options = element.getAttribute("data-module-modal-gallery-nav");
          options = JSON.parse(options || "{}");

      ModalGalleryNav(element, options);
    });
  });
})();

// Modal gallery products

(function module_page_modal_products() {
  function Self(element, events, options, module) {};

  function Slider(element, events, options, module) {
    $(element).slick({
      appendArrows: module.refs.arrows,
      prevArrow: "<button type='button' class='slick-prev'><i class='fa fa-chevron-left'></i></button>",
      nextArrow: "<button type='button' class='slick-next'><i class='fa fa-chevron-right'></i></button>"
    });
  };

  function ModalGalleryProducts(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      slider: element.querySelectorAll("[data-ref-slider]"),
      arrows: element.querySelectorAll("[data-ref-arrows]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.slider.forEach(function(element) {
      var options = element.getAttribute("data-ref-slider");
          options = JSON.parse(options || "{}");

      Slider(element, events, options, module);
    });
  };

   Events.on("modalgallery:trigger:open", function() {
    var elements = document.querySelectorAll("[data-module-modal-gallery-products]");

    elements.forEach(function(element) {
      var options = element.getAttribute("data-module-modal-gallery-products");
          options = JSON.parse(options || "{}");

      ModalGalleryProducts(element, options);
    });
  });
})();

// PDP stock widget

(function module_pdp_stock_widget() {
  console.log('stock'); 
  var quantity_input_element = document.querySelector("[data-pdp-quantity-input]");

  var pdp_stock_widget_element = document.querySelector("[data-pdp-stock-widget]");

  $(pdp_stock_widget_element).each(function(i, item) {
    console.log(item);
  });

  if (!quantity_input_element || !pdp_stock_widget_element) {
    return;
  }

  var pdp_stock_widget_options = pdp_stock_widget_element.getAttribute("data-pdp-stock-widget");
      pdp_stock_widget_options = JSON.parse(pdp_stock_widget_options || "{}");

  quantity_input_element.addEventListener("keyup", function(event) {
    if (pdp_stock_widget_options.inventory_management && +(event.target.value) <= pdp_stock_widget_options.inventory_quantity) {
      pdp_stock_widget_element.innerHTML = pdp_stock_widget_options.available;
    } else {
      pdp_stock_widget_element.innerHTML = pdp_stock_widget_options.unavailable;
    }
    
    // SV 06.02.20
    $('.large-orders-note')[event.target.value > pdp_stock_widget_options.inventory_quantity ? 'addClass' : 'removeClass']('hide');    
  });
})();

/*SV 10.06.19 - Color Dropdown*/
(function($) {
  function addItemToCart(p_options) {
    var data = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
    };

    if (p_options.properties !== undefined) {
      data['properties'] = p_options.properties
    }
    //console.log(data);
    
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(data) { 
          resolve(data);
        },
        error: function(error) { 
          reject(error);
        }
      });
    });
  }

  function buildColorOption(itemData, element, index) {
    //console.log(itemData);
    var option = '<a href="/products/' + itemData.element.data('product-handle') + '?variant=' + itemData.element.data('variantid') + '"><img class="small" src="' + itemData.element.data('image') + '" /><span>' + itemData.text + '</span></a>';
    if (index == 0) {
      option = itemData.text;
    }
    return option;
  }
  
  function addSearchColorInput() {
    $('.color-dropdown').find('.selectric').before('<div class="search-color"><input type="text" placeholder="Search color.." /></div>');
  }
  
  function onColorChange(e) {
    console.log(e);

    // Redirect to color link
    var href = $('.selectric-items').find('li.selected a').attr('href');
    window.location.href = href;
    return;

    var selectedColorLabel = $('#color-selection').val();
    $('.selectric .label').html($('.selectric-items').find('li.selected').html());

    // Update the master variant select (the hidden select that gets submitted)
    var variantId = $('#color-selection').find('option:selected').data('variantid');
    if (variantId) {
      var $masterSelect = $('select[name="id"]');
      if ($masterSelect.length) {
        $masterSelect.val(variantId);
        // Trigger change event so theme.js updates price, availability, etc.
        $masterSelect.trigger('change');
      }
    }

    // Update Product Title
    // var $productTitle = $('.product-title')
    // $productTitle.text(
    //   $productTitle.text().split(' - ')[0] + ' - ' + selectedColorLabel
    // );

    // Update selected color heading
    $('.color-heading span').text(selectedColorLabel);

    // Clear search input
    $('.search-color input').val('').trigger('input');

    var product_handle = $('#color-selection').find('option:selected').data('product-handle');
    var product = _.filter(_productImages, function(p) {
      return p.handle == product_handle;
    });

    // Switch Product images
    // if (!_.isUndefined(product)) {
    //   updateProductImages(product[0].images);
    // }

    // Update Sample button variant-id
    var selectColor = document.querySelector('#color-selection');
    var sampleVariant = product[0].product.variants[1].id;
    $('.sample-trigger').attr('data-id', parseInt(sampleVariant));
  }
  
  $(function() {
    $('select#color-selection').selectric({
      optionsItemBuilder: buildColorOption,
      onChange: onColorChange,
      onInit: function() {
        addSearchColorInput();
      },
      onOpen: function() {
        $('.color-dropdown').find('.search-color input').focus();
      }
    });
    
    $('select#color-selection').on('change', onColorChange);
    
    // Filter by Search
    $(document).on('input', '.search-color input', function(e) {
      var searchTerm = $(e.currentTarget).val().toLowerCase();
      $('.selectric-items').find('li').each(function(i, item) {
        $(item).removeClass('hide');
        var isMatch = $(item).find('span').text().toLowerCase().indexOf(searchTerm) !== -1;
        if (!isMatch) {
          $(item).addClass('hide');
        }
      });
    });
    
    // Add to Cart
    $(document).on('click', 'form.form--finishing-piece button[data-add-to-cart]', function(e) {
      e.preventDefault();
      var selectColor = document.querySelector('#color-selection');
      var variant = selectColor.options[selectColor.selectedIndex].getAttribute('data-variantid');
      var qty = $('#Quantity').val();
      
      if (selectColor.value == '') {
        alert('Select a Color to continue');
        return;
      }
      
      addItemToCart({
        variant_id: variant,
        quantity: qty
      })
      .then(function(data) {
        window.location.href = '/cart';
      });
    });
  });
  
  
})(jQuery);


(function($) {
  
  // Newsletter Bar
  $(document).on('click', '.newsletter-bar #x', function() {
    $('.newsletter-bar').addClass('done');
      
  });
  
  // Notification
  if(navigator.cookieEnabled){
    $(window).load( function() {
      if ($.cookie('popup') != "active") {
        setTimeout(function () {
            
            // prevent popup from showing in design mode
            if (typeof Shopify !== 'undefined' && Shopify.designMode) {
              return;
            }
      
            if ($('.notification-overlay').length){
              $height = $(window).height();
              $scrollTop = $(document).scrollTop();
              $('.notification-overlay').css('top', $scrollTop);
              $('.notification-overlay').css('height', $height);
              $('.notification-overlay').addClass('show');
              $('body').addClass('overlay-active');   
            }
          }, 300);
      }
    });

    $('.notification-overlay .notification').on('click', function(e) {
        e.stopPropagation(); 
    });

    $('.notification-overlay, .notification-overlay .x, .notification-overlay .btn').on('click',function(){
    
    $.cookie('popup', 'active', { expires: 3 });

    $('.notification-overlay').removeClass('show');
      $('body').removeClass('overlay-active'); 
    });
  }

  // Google Reviews
  $('.reviews-slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,
  });
  $('.reviews-slider + .arrow-left').click(function () {
    $('.reviews-slider').slick('slickPrev');
  });
  $('.reviews-slider + .arrow-left + .arrow-right').click(function () {
    $('.reviews-slider').slick('slickNext');
  });
  /*$(document).ready(function() {
    $.ajax({
      url: "https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/place/details/json?placeid=ChIJET3loJcts1IRcWu1Jrb2mt0&key=AIzaSyDOPNnkzL81Wwj7DsevXPniTa34WvdKiB8",
      dataType: "json",
      type: "GET", 
      success: function(json) {
        $.each(json.result.reviews, function(i,v) {
          if (i == 5) {
              return false;
          }
          var rating = v.rating;
          var text = v.text;
          if (rating == 5 && text.length < 600  ) {
            $slide = '<div>';
            $slide += '<div class="rating"><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i><i class="fa fa-star" aria-hidden="true"></i></div>';
            $slide += '<div class="review-text"><p>'+v.text+'</p></div>';
            $slide += '<h3>- '+v.author_name+'</h3>';
            $slide += '</div>';
            $('.reviews-slider').slick('slickAdd', $slide);
          }
        });
      },
      error: function(xhr, status, errorThrown) {
        //do something if there was an error. Right now it will just show the default values in the html
      }
    });
  });*/
  
  // Custom Design Hero Slider 
  $('.custom-hero-slider, .quiz-hero-slider, .color-slider').slick({ 
    slidesToShow: 1,
    fade: true, 
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    infinite: true,
    appendDots: $(".slick-custom-dots"),
    prevArrow: $(".slick-custom-prev"),
    nextArrow: $(".slick-custom-next")
  });

  // Featured Staff Slider
  $('.feat-staff-slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,
  })
  $('.feat-staff-slider + .arrow-left').click(function () {
    $('.feat-staff-slider').slick('slickPrev');
  });
  $('.feat-staff-slider + .arrow-left + .arrow-right').click(function () {
    $('.feat-staff-slider').slick('slickNext');
  });
  
  // Blog Comments
  $('a[href="#comments"]').on( "click", function(e) {
    $('#comment_form').addClass('show');
  });
  
  // Herringbone Product -> Collection Redirect
  if( $('a[href="/collections/patterns/products/2x6-herringbone-pattern-1036e-bluegrass"]').length ) {
    $('a[href="/collections/patterns/products/2x6-herringbone-pattern-1036e-bluegrass"]').attr('href','/collections/2x6-herringbone-pattern');
  }
  
  // Search Tags
  $('.search-tags .search-tag').on( "click", function() {
    var $tag = $(this).attr('data-tag');
    window.location.replace('https://mercurymosaics.com/search?q=' + $tag);
  });
  
  // Search Header
  $(document).ready(function() {
    var $referrer =  document.referrer;
    if(!~$referrer.indexOf('search?q=')) { // if previous page wasn't search
      $.cookie('referrer', $referrer, { expires: 1 });
    }
    $('.search-header #x').on( "click", function() {
      window.location.href = $.cookie('referrer');
    });
  });
  
  
  // Search Results
  $(document).ready(function() {
    $('.results-panel').each(function() {
      var results = $(this).find('.results-item');
      for(var i = 0; i < results.length; i+=4) {
        results.slice(i, i+4).wrapAll('<div class="results-set"></div>');
      }
      $(this).find('.results-set:first-of-type').addClass('set-show');
    });
    $('.results').addClass('loaded');
  });
  
  $('.search-nav li:not(.disabled)').on( "click", function() {
    $('.search-nav li.active').removeClass('active');
    $(this).addClass('active');
    var $cat = $(this).attr('data-cat');
    console.log($cat);
    if($cat == 'all') {
      $('.results .results-cat').removeClass('cat-hide');
    } else {
      $('.results .results-cat[data-cat="' + $cat + '"]').removeClass('cat-hide');
      $('.results .results-cat:not([data-cat="' + $cat + '"])').addClass('cat-hide');
    }
  });
  
  $('.results-panel .search-btn').on( "click", function() {
    $(this).parent('.search-btn-row').parent('.results-panel').find('.results-set.set-show').last().next('.results-set').addClass('set-show');
    if(!$(this).parent('.search-btn-row').parent('.results-panel').find('.results-set.set-show').last().next('.results-set').length) {
      $(this).hide();
    }
  });
  
  // Blog Filter
  if ($('#blog-nav').length) {
    
    // Init
    var $url = $(location).attr('href');
    if ( $url.indexOf('shop-by') >= 0 || $url.indexOf('commercial-gallery') >= 0 ) {
      $('.blog-nav').find('.blog-cat[data-cat="room"]').parent('.blog-cat-wrap').remove();
      $('.blog-nav').find('.blog-cat[data-cat="application"]').parent('.blog-cat-wrap').remove();
    }
    
    var $urlTags = $url.split('/').pop();
    var $tagArray  = $urlTags.split('+');
    console.log($tagArray);
    if ( $urlTags != 'news' && $urlTags != 'shop-by-kitchens' ) {
      if ( $urlTags != '' ) {
      	$('.blog-nav .reset').show();
      }
    }
    for ( var $i=0; $i<$tagArray.length; $i++ ) {
      var $tag = $tagArray[$i];
      var $tagButton = $('.blog-nav .tags').find('.blog-tag[data-tag="' + $tag + '"]');
      $tagButton.addClass('active');
      var $tagCat = $tagButton.parent('.blog-tags').attr('data-cat');
      var $tagCatNav = $('.blog-nav .blog-cats').find('.blog-cat[data-cat="' + $tagCat + '"]');
      if ( !$tagCatNav.hasClass('done') ) {
        $tagCatNav.addClass('active');
        $tagCatNav.find('.title span').text($tagButton.text());
        $tagCatNav.addClass('done');
      } else {
         $tagCatNav.find('.title span').append(', ' + $tagButton.text());
      }
      
    }
    
   // Ellipses
    var $catCount = $('.blog-nav .blog-cat').length; // to support fixed width for ellipses
    $('.blog-nav .blog-cats').addClass('cats-' + $catCount);
    
    function ellipses() {
      $('.blog-nav .blog-cat').each(function() {
        var $catWidth = $(this).width();
        var $catWidthInner = $(this).find('.title span').width();
        if ( ($catWidth - $catWidthInner) < 20 ) {
          $(this).addClass('ellipses');
        }
      });
    }
    
    ellipses();
    $(window).resize(function(){
      $('.blog-nav .blog-cat').removeClass('ellipses');
      ellipses();
    });
    
    // Ready
    $('.blog-nav .blog-cats').addClass('ready');

    // Panel
    $('.blog-nav .blog-cat').on( "click", function() { 
      if ( $(this).hasClass('panel-show') ) { // if the panel is already open
        $(this).removeClass('panel-show');
        $(this).parent('.blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        setTimeout(function () {
         $('.blog-nav .blog-tags').removeClass('show');
        }, 500);
        $('.blog-overlay').removeClass('show');
      } else { // if the panel isn't open
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $(this).addClass('panel-show');
        $(this).parent('.blog-cat-wrap').addClass('active');
        $('.blog-nav .blog-tags').removeClass('show');
        var $tagCat = $(this).attr('data-cat');
        $('.blog-nav .tags').find('.blog-tags[data-cat="' + $tagCat + '"]').addClass('show');
        if ( !$('.blog-nav-panel').hasClass('show') ) {
          
          /*var $catTop = $(this).offset().top;
          var $catHeight = $(this).height();
          var $catsHeight = $(this).parent('.blog-cat-wrap').parent('.blog-cats').height();
          //var $catsTop = $(this).parent('.blog-cat-wrap').parent('.blog-cats').offset().top
          //var $catOffset = $catsTop - $catTop;
          var $catOffset = $catTop - $catsHeight - $catHeight;
          console.log($catOffset);
          $('.blog-nav-panel').css('top', $catOffset);*/
          
          $('.blog-nav-panel').addClass('show');
          $('.blog-overlay').addClass('show');
        }
      }
      $('.blog-nav #x').on( "click", function() {
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
        $('.blog-overlay').removeClass('show');
      });
    });
	
    // Reset
    $('.blog-nav .reset').on( "click", function() {
      var $url = $(location).attr('href');
      if ($url.indexOf('shop-by-kitchens') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/shop-by-kitchens');
      } else if ($url.indexOf('shop-by-bathrooms') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/shop-by-bathrooms');
      } else if ($url.indexOf('shop-by-floors') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/shop-by-floors');
      } else if ($url.indexOf('shop-by-bars') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/shop-by-bars');
      } else if ($url.indexOf('commercial-gallery') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/commercial-gallery');
      } else if ($url.indexOf('custom-gallery') >= 0 ) {
        window.location.replace('https://mercurymosaics.com/blogs/custom-gallery');
      } else {
        window.location.replace('https://mercurymosaics.com/blogs/news');
      }
    });
    
    // Tags
    $('.blog-tags .blog-tag').on( "click", function() {
      
      var $tag = $(this).attr('data-tag');
      var $url = $(location).attr('href');
      
      var $tagSameCat = $(this).parent('.blog-tags').find('.blog-tag.active:not([data-tag="' + $tag + '"])');
      var $tagSameCatTag = $tagSameCat.attr('data-tag');
      if ( $tagSameCat.length > 0 ) { // if this cat already has an active tag, remove it
        var $url = $url.replace('+' + $tagSameCatTag, '');
        var $url = $url.replace($tagSameCatTag + '+', '');
        var $url = $url.replace($tagSameCatTag, '');
      }

      var $urlEnd = $url.substring($url.lastIndexOf('/') + 1);  
      if ($urlEnd.indexOf($tag) >= 0 ) { // if tag is already in use
        if ($urlEnd.indexOf('+') >= 0) { // if multiple tags in use
          var $url = $url.replace('+' + $tag, '');
          var $url = $url.replace($tag + '+', '');
          window.location.replace($url);
        } else {
      	  //window.location.replace('https://mercurymosaics.com/blogs/news');
        }
      } else { // if tag isn't in use  
        if ( $urlEnd == 'news' || $urlEnd == 'shop-by-kitchens' || $urlEnd == 'shop-by-bathrooms' || $urlEnd == 'shop-by-floors' || $urlEnd == 'shop-by-bars' || $urlEnd == 'commercial-gallery' || $urlEnd == 'custom-gallery' ) {
          window.location.replace($url + '/tagged/' + $tag);
        } else if ($urlEnd == '' ) {
          if ($url.indexOf('tagged') >= 0) { // if tagged is in url
            window.location.replace($url + $tag);
          } else {
            window.location.replace($url + 'tagged/' + $tag);
          }
        } else {
           window.location.replace($url + '+' + $tag);
        }
      }
      
    });
    
  };
  
  // Collections Filter
  if ($('#collection-filter').length) {
  
   // Ellipses
   var $catCount = $('.blog-nav .blog-cat').length; // to support fixed width for ellipses
    $('.blog-nav .blog-cats').addClass('cats-' + $catCount);
    
    function ellipses() {
      $('.blog-nav .blog-cat').each(function() {
        var $catWidth = $(this).width();
        var $catWidthInner = $(this).find('.title span').width();
        if ( ($catWidth - $catWidthInner) < 20 ) {
          $(this).addClass('ellipses');
        }
      });
    }
    ellipses();
    
    $(window).resize(function(){
      $('.blog-nav .blog-cat').removeClass('ellipses');
      ellipses();
    });
    
    $('.blog-nav .blog-cats').addClass('ready');
    
    // Collect Data
    var colors = [];
    var shapes = [];
    var sizes = [];
    $('.product-listing').each(function() {
     
      newColor = $(this).attr('data-color');
      if($.inArray(newColor, colors)<0) {
        colors.push(newColor);
      } 
      
      newShape = $(this).attr('data-shape');
      if($.inArray(newShape, shapes)<0) {
        shapes.push(newShape);
      } 

      newSize = $(this).attr('data-size');
      if($.inArray(newSize, sizes)<0) {
        sizes.push(newSize);
      } 
      
    });
    
    colors.sort();
    shapes.sort();
    sizes.sort();
    console.log(colors);
    console.log(shapes);
    console.log(sizes);
    
    // Populate Tags
    var i;
    for (i = 0; i < colors.length; ++i) {
      $('.blog-tags[data-cat="Color"]').append('<div class="blog-tag search-btn" data-tag="' + colors[i] + '">' + colors[i] + '</div>');
    }
    
    //if( shapes.length > 1 ) {
      var i;
      for (i = 0; i < shapes.length; ++i) {
          $('.blog-tags[data-cat="Shape"]').append('<div class="blog-tag search-btn" data-tag="' + shapes[i] + '">' + shapes[i] + '</div>');
      }
    /*} else {
      $('.blog-cat[data-cat="Shape"]').parent().remove();
      $('.blog-cat[data-cat="Quantity"]').parent().remove();
    }*/

    var i;
    for (i = 0; i < sizes.length; ++i) {
        $('.blog-tags[data-cat="Size"]').append('<div class="blog-tag search-btn" data-tag="' + sizes[i] + '">' + sizes[i] + '</div>');
    }
    
    // Ready
    $('.blog-nav .blog-cats').addClass('ready');
    
    // Panel
    $('.blog-nav .blog-cat').on( "click", function() { 
      if ( $(this).hasClass('panel-show') ) { // if the panel is already open
        $(this).removeClass('panel-show');
        $(this).parent('.blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        setTimeout(function () {
         $('.blog-nav .blog-tags').removeClass('show');
        }, 500);
        $('.blog-overlay').removeClass('show');
      } else { // if the panel isn't open
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $(this).addClass('panel-show');
        $(this).parent('.blog-cat-wrap').addClass('active');
        $('.blog-nav .blog-tags').removeClass('show');
        var $tagCat = $(this).attr('data-cat');
        $('.blog-nav .tags').find('.blog-tags[data-cat="' + $tagCat + '"]').addClass('show');
        if ( !$('.blog-nav-panel').hasClass('show') ) {
          $('.blog-nav-panel').addClass('show');
          $('.blog-overlay').addClass('show');
        }
      }
      $('.blog-nav #x').on( "click", function() {
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
        $('.blog-overlay').removeClass('show');
      });
    });
    
    // Reset
    $('.blog-nav .reset').on( "click", function() {
      
      $('.blog-cat').each(function() {
        var $cat = $(this).attr('data-cat');
        $(this).find('span').text($cat);
        $(this).removeClass('active');
      });
      ellipses();
      
      $('.blog-tag').removeClass('active');
      
      $('.product-listing').show();
      
      $('.blog-nav .reset').hide();
      
    });
    
    $('.blog-cat[data-cat="Shape"]').find('span').text('Shape');
    $('.blog-cat[data-cat="Size"]').find('span').text('Size');
    $('.blog-cat[data-cat="Color"]').find('span').text('Color');
    
    
    // Tags
    $('.blog-tags .blog-tag').on( "click", function() {
      $('.no-results').remove();
      var $cat = $(this).parent().attr('data-cat');
      console.log($cat);
      var $tag = $(this).attr('data-tag');
      var $text = $(this).text();
      if ( $(this).hasClass('active') ) { // if current tag is active
        $(this).removeClass('active');
        $('.product-listing').hide();
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
        $('.blog-overlay').removeClass('show');
        $('.blog-cat[data-cat="' + $cat + '"]').find('span').text($cat);
        ellipses();
        $('.blog-cat[data-cat="' + $cat + '"]').removeClass('active')
        // Other Categories
        if( $('.blog-cat.active').length == 0 ) {
          $('.product-listing').show();
          console.log('no other active cats');
        } else {
          console.log('other active cats');
          $('.blog-cat.active').each(function() {
            var $cat = $(this).attr('data-cat');
            var $tag = $('.blog-tags[data-cat="' + $cat + '"]').find('.blog-tag.active').attr('data-tag');
            console.log($tag);
            if ( $cat == 'Quantity' ) {
              $('.product-listing').each(function() {
                var $qty = $(this).attr('data-quantity');
                if( parseInt($qty) >= parseInt($tag) ) {
                  $(this).show();
                }
              });
            } else {
              $('.product-listing').each(function() {
                if( $(this).attr('data-shape') == $tag || $(this).attr('data-size') == $tag || $(this).attr('data-color') == $tag || $(this).attr('data-product-type') == $tag ) {
                  $(this).show();
                }
              });
            }
          });
        };
      } else { // if current tag isn't active
        $('.product-listing').hide();
        $(this).parent().find('.active').removeClass('active');
        $(this).addClass('active');
        if ( $cat == 'Quantity' ) {
          $('.product-listing').each(function() {
            var $qty = $(this).attr('data-quantity');
            if( parseInt($qty) >= parseInt($tag) ) {
              $(this).show();
            }
          }); 
        } else { // shape or color
          $('.product-listing').each(function() {
            if( $(this).attr('data-shape') == $tag || $(this).attr('data-size') == $tag || $(this).attr('data-color') == $tag || $(this).attr('data-product-type') == $tag ) {
              $(this).show();
            }
          });
        }
        // Other Categories
        if( $('.blog-cat.active').length == 0 ) {
          console.log('no other active cats');
        } else {
          console.log('other active cats');
          if ( $tag == 'Stove Splash' ) {
            console.log('stove splash: disable all other filters');
            $('.blog-cat.active:not([data-cat="' + $cat + '"])').each(function() {
              $(this).removeClass('active');
              $(this).find('span').text($(this).attr('data-cat')); 
            });
            $('.blog-tags:not([data-cat="' + $cat + '"])').each(function() {
              $(this).find('.blog-tag.active').removeClass('active');
            });
          } else {
            $('.blog-cat.active:not([data-cat="' + $cat + '"])').each(function() {
              var $cat = $(this).attr('data-cat');
              var $tag = $('.blog-tags[data-cat="' + $cat + '"]').find('.blog-tag.active').attr('data-tag'); 
              console.log($tag);
              if ( $cat == 'Quantity' ) {
                $('.product-listing').each(function() {
                  var $qty = $(this).attr('data-quantity');
                  if( parseInt($qty) < parseInt($tag) ) {
                     console.log('hide');
                    $(this).hide();
                  }
                });
              } else {
                console.log($cat);
                $('.product-listing:visible').each(function() {
                  if( $(this).attr('data-shape') != $tag && $(this).attr('data-size') != $tag && $(this).attr('data-color') != $tag && $(this).attr('data-quantity') != $tag && $(this).attr('data-product-type') != $tag ) {
                    $(this).hide();
                  }
                });
              }
            });
          }
        };
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
        $('.blog-overlay').removeClass('show');
        if ( $cat == 'Quantity' ) {
          $('.blog-cat[data-cat="' + $cat + '"]').find('span').text($text);
        } else {
          $('.blog-cat[data-cat="' + $cat + '"]').find('span').text($tag);
        }
        ellipses();
        $('.blog-cat[data-cat="' + $cat + '"]').addClass('active')
        $('.blog-nav .reset').show();
        if ( $('.product-listing:visible').length == 0 ) {
          $('.collection-content').append('<h2 class="no-results">No results for current filter.</h2>');
        }
      }
      
    });
    
  };
  
  // Colors Filter
  if ($('#colors-nav').length) {
    
    // Ellipses
    function ellipses() {
      $('.blog-nav .blog-cat').each(function() {
        var $catWidth = $(this).width();
        var $catWidthInner = $(this).find('.title span').width();
        if ( ($catWidth - $catWidthInner) < 20 ) {
          $(this).addClass('ellipses');
        } else {
          if ($(this).hasClass('ellipses')) {
            $(this).removeClass('ellipses');
          }
        }
      });
    }
    
    // Panel
    $('.blog-nav .blog-cat').on( "click", function() { 
      if ( $(this).hasClass('panel-show') ) { // if the panel is already open
        $(this).removeClass('panel-show');
        $(this).parent('.blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        setTimeout(function () {
         $('.blog-nav .blog-tags').removeClass('show');
        }, 500);
        $('.blog-overlay').removeClass('show');
      } else { // if the panel isn't open
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $(this).addClass('panel-show');
        $(this).parent('.blog-cat-wrap').addClass('active');
        $('.blog-nav .blog-tags').removeClass('show');
        var $tagCat = $(this).attr('data-cat');
        $('.blog-nav .tags').find('.blog-tags[data-cat="' + $tagCat + '"]').addClass('show');
        if ( !$('.blog-nav-panel').hasClass('show') ) {       
          $('.blog-nav-panel').addClass('show');
          $('.blog-overlay').addClass('show');
        }
      }
      $('.blog-nav #x').on( "click", function() {
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
        $('.blog-overlay').removeClass('show');
      });
    });
    
    // Tags
    $('.blog-tags .blog-tag').on( "click", function() {
      $('.no-results').remove();
      var $cat = $(this).parent().attr('data-cat');
      var $tag = $(this).attr('data-tag');
      var $text = $(this).text();
      $('.color').hide();
      $('.color').removeClass('show');
      $('.color').removeClass('color-show');
      $('.color').removeClass('variation-show');
      $('.color').removeClass('finish-show');
      
      if ( $(this).hasClass('active') ) { // if current tag is active
        $(this).removeClass('active');
        $('.blog-cat[data-cat="' + $cat + '"]').removeClass('active');
        $('.blog-cat[data-cat="' + $cat + '"] .title span').text($cat);
        ellipses();
      } else { // if current tag isn't active
        //if ($cat != 'color') { // not color, turn off other options
          //$('.blog-tags[data-cat="' + $cat + '"] .blog-tag').removeClass('active');
          $('.blog-cat[data-cat="' + $cat + '"] .title span').text($text);
          ellipses();
        //}
        $(this).addClass('active');
        $('.blog-cat[data-cat="' + $cat + '"]').addClass('active')
      }
      
      /*if ($cat != 'color') { // not color, close everything
        $('.blog-nav .blog-cat').removeClass('panel-show');
        $('.blog-nav .blog-cat-wrap').removeClass('active');
        $('.blog-nav-panel').removeClass('show');
        $('.blog-nav .blog-tags').removeClass('show');
      } else { // do color stuff*/
        var $str = '';
        $('.blog-tags[data-cat="' + $cat + '"] .blog-tag.active').each(function(i) {
            $text = $(this).text();
          	if (i == 0) {
              $str = $text;
            } else {
          	  $str = $str.concat(', ', $text);
            }
        });
        $('.blog-cat[data-cat="' + $cat + '"] .title span').text($str);
        if ($('.blog-tags[data-cat="' + $cat + '"] .blog-tag.active').length == 0) {
          $('.blog-cat[data-cat="' + $cat + '"]').removeClass('active');
          $('.blog-cat[data-cat="' + $cat + '"] .title span').text($cat);
        }
        ellipses();
      /*}*/
      
      // Filter   
      // check colors tags
      if ($('.blog-tags[data-cat="color"] .blog-tag.active').length == 0) { // if none selected
        $('.colors .color').addClass('color-show');
      } else {
        $('.blog-tags[data-cat="color"] .blog-tag.active').each(function() {
          var color = $(this).attr('data-tag');
          if (color == 'best+sellers') {
            color = 'best-seller';
          }
          $('.colors .color').each(function() {
            if ($(this).hasClass(color)) {
              $(this).addClass('color-show');
            }
          });
        });
      };
      // check variation tags
      if ($('.blog-tags[data-cat="variation"] .blog-tag.active').length == 0) { // if none selected
        $('.colors .color').addClass('variation-show');
      } else {
        $('.blog-tags[data-cat="variation"] .blog-tag.active').each(function() {
          var variation = $(this).attr('data-tag');
          $('.colors .color').each(function() {
            if ($(this).hasClass(variation)) {
              $(this).addClass('variation-show');
            }
          });
        });
      };
      // check finish tags
      if ($('.blog-tags[data-cat="finish"] .blog-tag.active').length == 0) { // if none selected
        $('.colors .color').addClass('finish-show');
      } else {
        $('.blog-tags[data-cat="finish"] .blog-tag.active').each(function() {
          var finish = $(this).attr('data-tag');
          $('.colors .color').each(function() {
            if ($(this).hasClass(finish)) {
              $(this).addClass('finish-show');
            }
          });
        });
      };
      
      /*// check variation tags
      var variation = $('.blog-tags[data-cat="variation"] .blog-tag.active').attr('data-tag');
      if(variation) {
        if (~variation.indexOf('+')) {
          var variations = variation.split('+');
          var variation1 = variations[0];
          var variation2 = variations[1];
          $('.colors .color.show').each(function() {
            if ($(this).hasClass(variation1) || $(this).hasClass(variation2)) {} else {
              $(this).removeClass('show');
            }
          });
        } else {
          $('.colors .color.show').each(function() {
            if ($(this).hasClass(variation)) {} else {
              $(this).removeClass('show');
            }
          });
        };
      };
      // check finish tags
      var finish = $('.blog-tags[data-cat="finish"] .blog-tag.active').attr('data-tag');
      if(finish) {
        if (~finish.indexOf('+')) {
          var finishes = finish.split('+');
          var finish1 = finishes[0];
          var finish2 = finishes[1];
          $('.colors .color.show').each(function() {
            if ($(this).hasClass(finish1) || $(this).hasClass(finish2)) {} else {
              $(this).removeClass('show');
            }
          });
        } else {
          $('.colors .color.show').each(function() {
            if ($(this).hasClass(finish)) {} else {
              $(this).removeClass('show');
            }
          });
        };
      };*/
	  
      $('.colors .color').each(function() {
        if ($(this).hasClass('color-show') && $(this).hasClass('variation-show') && $(this).hasClass('finish-show')) {
          $(this).addClass('show');
        }
      });
      
      if ( $('.colors .color:visible').length == 0 ) {
        $('.colors').append('<h2 class="no-results">No results for current filter.</h2>');
      }
      $('.blog-nav .reset').show();
 
    });
      
 	// Reset
    $('.blog-nav .reset').on( "click", function() {
      $('.no-results').remove();
      $('.blog-cat').each(function() {
        var $cat = $(this).attr('data-cat');
        $(this).find('span').text($cat);
        $(this).removeClass('active');
      });
      $('.blog-tag').removeClass('active');
      $('.color').addClass('show');
      $('.blog-nav .reset').hide();
    });

    // OLD
    if ($('.colors-body.old').length) {
      
      // Popup (old)
      var selectors = {
        img: '.color img',
        popup_products: '#popup-products',
        popup_noproducts: '#popup-no-products'
      };
      
      var popup_type = selectors.popup_noproducts;

      // Load All products (old)
      var products = [];
      var productsURL = '/collections/best-sellers/products.json?limit=1000';
      $.getJSON(productsURL, function(data) {
        products = data.products || [];
  
        // If direct link with color name used
        if (location.hash.length) {
          setTimeout(function() {
            $('.btn.fancybox[href*="' + location.hash + '"]').trigger('click');
          },100);
        }
      });

      // Open color palette popup (old)
      $('.colors-body.old .fancybox').on('click', function() {
        var colorName = $(this).data('color');
        var colorProps = $(this).parent().find('h4').html();
        var colorDesc = $(this).parent().find('.desc').text();
        var colorImgs = []
   
        if ($(this).hasClass('img')) {
          var colorSwatch = $(this).parent().parent().parent('.panel').find('img').attr('src');
          var colorImg = $(this).attr('style');
          $(this).parent().parent().parent().parent('.color').find('.slider-images span').each(function() {
            var url = $(this).attr('data');
            colorImgs.push(url);
          });
        } else if ($(this).hasClass('img-main')) {
          var colorSwatch = $(this).attr('src');
          var colorName = $(this).parent('.panel').find('.img').data('color');
          var colorProps = $(this).parent().find('.expand h4').html();
          var colorImg = $(this).parent('.panel').find('.img').attr('style');
          $(this).parent().parent('.color').find('.slider-images span').each(function() {
            var url = $(this).attr('data');
            colorImgs.push(url);
          });
        } else { // button
          var colorSwatch = $(this).parent().parent().parent().parent('.panel').find('img').attr('src');
          var colorImg = $(this).parent().parent('.expand').find('.img').attr('style');
           $(this).parent().parent().parent().parent().parent('.color').find('.slider-images span').each(function() {
            var url = $(this).attr('data');
            colorImgs.push(url);
          });
        };
        
        addPopupContent({
          colorName: colorName,
          colorProps: colorProps,
          colorDesc: colorDesc,
          colorSwatch: colorSwatch,
          colorImg: colorImg,
          colorImgs: colorImgs,
          onComplete: function() {
            Fancybox.show([{
                src  : popup_type,
                type : 'inline',
                opts : {
                  beforeLoad: function() {},
                  afterShow : function(instance, current) {}
                },
                helpers: {
                  overlay: {
                    locked: false
                  }
                }
            }]);
            /*$.fancybox.open({
              src  : popup_type,
              type : 'inline',
              opts : {
                beforeLoad: function() {},
                afterShow : function(instance, current) {}
              },
              helpers: {
                overlay: {
                  locked: false
                }
              }
            });*/
          }
        });
      });
  
      function addPopupContent(options) {
        var colorName = options.colorName,
            colorProps = options.colorProps;
            colorDesc = options.colorDesc;
        	  colorSwatch = options.colorSwatch;
        	  colorImg = options.colorImg;
            colorImgs = options.colorImgs;

        // Assign products
        var filterProductsByColorName = [];
        if (products && products.length) {
          filterProductsByColorName = _.filter(products, function(product) {
            var tags = product.tags.join(',').toLowerCase();
            var title = product.title.toLowerCase();

            return tags.indexOf(colorName.toLowerCase()) > -1 || title.indexOf(colorName.toLowerCase()) > -1;
          });
        }

        if (filterProductsByColorName.length) {
          popup_type = selectors.popup_products;
  
          $('.products', popup_type).html('');
          $('.products-blends p', popup_type).html('');
          $('.products-blends').hide();
          
          _.each(filterProductsByColorName, function(product, index) {
            if (index < 6) {
              if (~product.title.indexOf('Blend')) {
                var productTitle = product.title.split(' - ');
                $('.products-blends p', popup_type).append('<a href="/products/' + product.handle + '">' + productTitle[0] + '<br/>' + productTitle[1] + '</a>');
                $('.products-blends').show();
              } else {
                var productTitle = product.title.split(' - ');
                $('.products', popup_type).append('<a href="/products/' + product.handle + '">' + productTitle[0] + '</a>');
              };
            }
          });
        }
        else {
          popup_type = selectors.popup_noproducts;
        }
  
        $('.color-name', popup_type).html('<h2>' + colorName + '</h2>');
        //$('.img', popup_type).attr('style', colorImg);
        if ($('.popup-slider', popup_type).hasClass('slick-slider')) {
          $('.popup-slider', popup_type).slick('unslick');
        }
        $('.popup-slider .slide', popup_type).remove(); // clear
        $('.popup-slider', popup_type).addClass('loading');
        $('.popup-slider', popup_type).append('<div class="slide"><div><div class="img-wrap"><img src="' + colorSwatch + '" /></div></div></div>');
        $('.popup-slider', popup_type).append('<div class="slide" style="' + colorImg + '"></div>');
        $.each(colorImgs, function(index, item) {
          $('.popup-slider', popup_type).append('<div class="slide" style="background-image: url(' + item + ');"></div>');
        });
        
        $('.color-props', popup_type).html('<h4>' + colorProps + '</h4>');
        $('.color-desc', popup_type).html('<p>' + colorDesc + '</p>');
        var colorCode = colorName.split(' ');
        $('.btn', popup_type).attr('href', '/pages/contact?color=' + colorCode[0])
  
        $('.popup-slider', popup_type).slick({
          slidesToShow: 1,
          arrows: true,
          dots: true,
          infinite: true,
  
        })
        .on('setPosition', function (event, slick) {
          slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });
        $('.popup-slider', popup_type).slick('slickGoTo', 0);
        setTimeout(function() { 
          $('.popup-slider', popup_type).removeClass('loading');
        }, 500);
        
        options.onComplete();
      }

    }; // end old
 
  };
  
  // Colors Contact
  if ($('.template-page.contact').length) {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('color')) {
      let color = searchParams.get('color')
      $('select[name="MultipleChoice2"] option').prop('selected', false);
	  var $list = $('select[name="MultipleChoice2"]');
	  var $option = $('.free-quote-body select[name="MultipleChoice2"] option:contains("' + color + '")');  
      $option.prop('selected', true); 
    }
  }
  
  // Trade Login
  if ($('#redirect_url').length) {
    var $url =  window.location.href; 
  	$("#redirect_url").val($url);
  }
  
  // Redirect Variant to Parent Product
  // $( document ).ready(function() {
	// var getUrlParameter = function getUrlParameter(sParam) {
  //       var sPageURL = window.location.search.substring(1),
  //           sURLVariables = sPageURL.split('&'),
  //           sParameterName,
  //           i;
  //       for (i = 0; i < sURLVariables.length; i++) {
  //           sParameterName = sURLVariables[i].split('=');
  //           if (sParameterName[0] === sParam) {
  //               return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
  //           }
  //       }
  //   }                                    
  //   variant = getUrlParameter('variant');                                    
  //   if(variant != undefined) {  
  //     var url =  window.location.href; 
  //     base = url.replace(/\?.*$/g,"");
  //     window.location.replace(base);
  //   } 
  // });
  
  // Blends Slider
  $('.blends-slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,
  });
  $('.blends-slider').on('afterChange', function(){
    var $active = $('.blends-slider .slick-current').attr('data-slick-index');   
    $('.bg-img .bg').removeClass('show');
    $('.bg-img .bg[data-id="' + $active + '"]').addClass('show');
  });

  // Trade Partners Sliders
  $('#partner-slider-1').slick({
    slidesToShow: 1,
    fade: true, 
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    infinite: true,
    appendDots: $(".slick-custom-dots-1"),
    prevArrow: $(".slick-custom-prev-1"),
    nextArrow: $(".slick-custom-next-1")
  });
  $('#partner-slider-2').slick({ 
    slidesToShow: 1,
    fade: true, 
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    infinite: true,
    appendDots: $(".slick-custom-dots-2"),
    prevArrow: $(".slick-custom-prev-2"),
    nextArrow: $(".slick-custom-next-2")
  });
  $('#partner-slider-1').on('afterChange', function(){
    var $active = $('#partner-slider-1 .slick-current').attr('data-slick-index');   
    $('.partner-1 .details').removeClass('show');
    $('.partner-1 .details[data-id="' + $active + '"]').addClass('show'); 
  });
  $('#partner-slider-2').on('afterChange', function(){
    var $active = $('#partner-slider-2 .slick-current').attr('data-slick-index');   
    $('.partner-2 .details').removeClass('show');
    $('.partner-2 .details[data-id="' + $active + '"]').addClass('show'); 
  });
  
  // Careers 
  $('.career-location').on( "click", function() {
    $('.career-location').removeClass('active');
    $(this).addClass('active');
    var $loc = $(this).attr('data-location');
    $('.careers-position.active').removeClass('active');
    setTimeout(function() { 
      if ($loc == 'all') {
        $('.careers-position').addClass('active');
      } else {
        $('.careers-position[data-location="' + $loc + '"]').addClass('active');
      }
    }, 300);
  });

  // Blog Promos
  if ($('.template-article').length) {
    function promo($elm, type, title, content, button, link, img, alt) {
      $elm.before(`
        <div class="promo-rendered promo-${type} flex space">
          <div class="img v-flex">
            <a href="${link}"><img src="${img}" alt="${alt}" /></a>
          </div>
          <div class="content flex-v text-center">
            <h2><a href="${link}">${title}</a></h2>
            <p>${content}</p>
            <div class="btn-row">
              <a class="btn alt" href="${link}">${button}</a>
            </div>
          </div>
        </div>
      `)
    };
    function random(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    if ($('.promo').length) { // manual
      $('.promo').each(function() {
        var $elm = $(this);
        var type = $elm.data('type');
        var title = $elm.data('title');
        var content = $elm.data('content');
        var button = $elm.data('button');
        var link = $elm.data('link');
        var img = $elm.find('img').attr('src');
        var alt = $elm.find('img').attr('alt');
        promo($elm, type, title, content, button, link, img, alt); 
      });
    } else { // auto
      var tags = $('.auto-promos').data('tags');
      var i = 0;
      // tag match
      $('.auto-promo').each(function(index) {
        var tag = $(this).data('tag');
          if (tag != '' && ~tags.indexOf(tag) && i == 0) { 
            console.log('promo tag match: ' + tag);
            i = index + 1;
          }
      });
      // random
      if (i == 0) {
        i = random(1, $('.auto-promo').length);   
      }
      // data
      var $promo = $('.auto-promo:nth-of-type(' + i + ')');
      var type = $promo.data('type');
      var title = $promo.data('title');
      var content = $promo.data('content');
      var button = $promo.data('button');
      var link = $promo.data('link');
      var img = $promo.find('img').attr('src');
      var alt = $promo.find('img').attr('alt');
      var h2 = Math.floor( $('article div[itemprop="articleBody"] h2').length / 2 );
      $elm = $('article h2:eq(' + h2 + ')');
      promo($elm, type, title, content, button, link, img, alt);
    }
  }  
})(jQuery);


// PRODUCT CUSTOMIZER
$( document ).ready(function() {
  var $productBlendsSection = $('#shopify-section-product-blends');

  if(!$productBlendsSection.length){
    return;
  }

  var blendColors = [];
      
  // Preview Height - Squares
  function squaressHeight() {
      var $squaresPreview = $('.preview[data-shape="squares"]');
      if (!$squaresPreview.length || !$squaresPreview.attr('data-col')) {
          return;
      }
      var $squaresWidth = $squaresPreview.width();
      var $squaresCol = $squaresPreview.attr('data-col').split('-')[1];
      $squaresPreview.height($squaresWidth + ($squaresCol * 2)); // math accounts for borders
      $squaresPreview.find('.preview-overlay').height($squaresWidth + ( ($squaresCol * 2) - 1) );
      $squaresPreview.css('opacity', 1);
  } 
      
  // Preview Height - Diamonds
  function diamondsHeight() {
      var $diamondsPreview = $('.preview[data-shape="diamonds"]');
      if (!$diamondsPreview.length || !$diamondsPreview.attr('data-col')) {
          return;
      }
      var $diamondsWidth = $diamondsPreview.width();
      var $diamondsCol = $diamondsPreview.attr('data-col').split('-')[1];
      var $cubeWidth = (($diamondsWidth / $diamondsCol));
      var $tileWidth = Math.floor($cubeWidth / 1.75);

      $diamondsPreview.height($diamondsWidth);
      $('.preview .diamonds-row').css('margin-bottom', Math.round($cubeWidth * -.265) + 4 );
      $('.preview .diamonds-row:first-child').css('margin-top', Math.round($cubeWidth * -.95) );
      $('.preview .diamonds-row:nth-child(odd)').width($diamondsWidth + $cubeWidth).css('left', Math.round($cubeWidth / -2));
      $('.preview .cube-wrap').width($cubeWidth - 16);
      $('.preview .cube-wrap').height( $tileWidth * 2 );
      $('.preview .cube .tile').width( $tileWidth ).height( $tileWidth );
      $diamondsPreview.css('opacity', 1);
  } 

  // update Colors Array
  function updateColors(){
      blendColors = [];

      var $blendColors = $('#blend-colors .swatch.active');
      $blendColors.each(function() {
          var $this = $(this);
          var color = $this.data('color');
          var colorName = $this.data('color-name');
          var colorPercent = $this.closest('.blend-color').find('input.color-percent').val();
          var colorPercentInt = parseInt(colorPercent, 10);

          var newColor = {
              color: color,
              colorName: colorName,
              colorPercent: colorPercentInt
          };

          blendColors.push(newColor);
      });

      let productNoteText = blendColors.map(color => `${color.colorName} ${color.colorPercent}%`).join(', ');
      $('#product-note').val(productNoteText);

      updatePreview();
  }

  // Reset Percentages after adding or removing a color
  function resetPercentages(){
      var initialPercentages = [
          [80, 20],
          [50, 25, 25],
          [50, 20, 20, 10],
          [50, 15, 15, 10, 10],
          [50, 10, 10, 10, 10, 10],
          [40, 10, 10, 10, 10, 10, 10],
          [30, 10, 10, 10, 10, 10, 10, 10]
      ];
      var $activeInputs = $('.colors .set.active input');
      var activeCount = $activeInputs.length;
      var percentages = initialPercentages[activeCount - 2];

      $activeInputs.each(function(index){
          $(this).val(percentages[index]);
          $(this).attr('value', percentages[index]);
      });

      updateSelectedVariant();
  }

  function updateSelectedVariant(){
      var $option1Input = $('.selector-wrapper input[value="2-4"]');
      var $option2Input = $('.selector-wrapper input[value="5-8"]');
      var $activeInputs = $('.colors .set.active');
      var activeCount = $activeInputs.length;
      var $sample1Btn = $('.sample-trigger#sample-1');
      var $sample2Btn = $('.sample-trigger#sample-2');

      if($option1Input.length && $option2Input.length){
          if(activeCount < 5){
              if(!$option1Input.prop('checked')){
                $option1Input.prop('checked', true).trigger('change');

                if($sample1Btn){
                  $sample1Btn.show();
                }
                if($sample2Btn){
                  $sample2Btn.hide();
                }
              }
          } else {
            if(!$option2Input.prop('checked')){
              $option2Input.prop('checked', true).trigger('change');

              if($sample1Btn){  
                $sample1Btn.hide();
              }
              if($sample2Btn){
                $sample2Btn.show();
              }  
            }
          }    
      }
  }

  function getRandomIntegers(count, max) {
      // Create an array of integers from 0 to max-1
      let arr = Array.from({ length: max }, (_, i) => i);
      
      // Shuffle the array using Fisher-Yates algorithm
      for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      
      // Return the first 'count' elements
      return arr.slice(0, count);
  }

  // Update Preview                                                                 
  function updatePreview() {  
      $('.tile.show').removeClass('color-1 color-2 color-3 color-4 color-5 color-6 color-7 color-8').addClass('no-color');

      var $activeTiles = $('.preview.active .tile.show');
      $activeTiles.css('background-image', 'none');

      var $openTiles = $('.preview.active .tile.show.no-color');
      var tileCount = $activeTiles.length;

      var $sets = $('#blend-colors .set');

      for (var i = 1; i < 9; i++) { 
        var $currentSet = $sets.eq(i - 1);
          if( $currentSet.find('.swatches').hasClass('selected') ) {
              var imgSrc = $currentSet.find('.swatch.active').css('background-image');
              var percent = $currentSet.find('input').val();
              var tilesInColor = Math.ceil(tileCount * (percent / 100));

              if($openTiles.length){
                  $openTiles = $('.preview.active .tile.show.no-color');
                  var randomIntegers = getRandomIntegers(tilesInColor, $openTiles.length);
                  
                  randomIntegers.forEach(randomInt => {
                      var $tile = $openTiles.eq(randomInt);
                      $tile.css('background-image', imgSrc);
                      $tile.removeClass('no-color');
                      $tile.addClass('color-' + i);
                  }); 
              }
          }
      }
  }

  // Remove Color
  function removeColor() {
      var $container = $('#blend-colors');
      var $parent = $(this).parent('.blend-color');

      $parent.removeClass('active show-swatches color-selected');
      $parent.find('.swatch.active').removeClass('active');
      $parent.find('.swatches').removeClass('selected');
      $parent.find('.color-preview').removeAttr('style');
      $parent.appendTo($container);
      var $allSets = $container.find('.blend-color');
      
      $allSets.each(function(i, el){
        if(!$(el).hasClass('color-selected')){
          $(el).find('.color-name').text('Color ' + (i + 1));
        }
      });  

      activeCount = $('.colors .set.active').length; 
      
      if (activeCount < 8) {
          if ($('.add-set').hasClass('disabled')) {                                                         
              $('.add-set').removeClass('disabled');
          }
      }

      resetPercentages();
      updateColors();
  }

  function selectColor() {
      var $parent = $(this).closest('.blend-color');
      var colorName = $(this).data('color-name');
      var colorStyle = $(this).attr('style');
      $(this).addClass('active').siblings('.active').removeClass('active');
      $(this).parent().addClass('selected');
      $parent.find('.color-name').text(colorName);
      $parent.find('.color-preview').attr('style', colorStyle);
      $parent.addClass('color-selected');
      
      updateColors();
  }

  function addColor() {
      var $nextColor = $('.colors').find('.set.active').last().next('.set');
      $nextColor.addClass('active show-swatches');
      activeCount = $('.colors .set.active').length;
      
      if (activeCount > 7) {
          $(this).addClass('disabled');
      }
      
      resetPercentages();
  }

  function updatePercentage() {     
      var $parent = $(this).closest('.blend-color');
      var currentInputIndex = $parent.index();                                                          
      var newVal = parseInt($(this).val(), 10);
      var activeCount = $('.colors .set.active').length;
      var maxVal = 100 - (activeCount - 1) * 5;
      var minVal = 5;
      var $inputs = $('.set.active input');
      var count = 0;
  
      // Clamp the value between minVal and maxVal and update input
      newVal = Math.max(minVal, Math.min(newVal, maxVal));
      $(this).val(newVal);
      $(this).attr('value', newVal);

      adjustValues();
      
      function adjustValues() {
          var inputVals = [];

          $inputs.each(function(i, el) {
              inputVals.push(parseInt($(el).val(), 10));    
          });

          var currentMinVal = Math.min(...inputVals.filter((input, index) => index !== currentInputIndex));
          var currentMaxVal = Math.max(...inputVals.filter((input, index) => index !== currentInputIndex));
          
          var totalSum = inputVals.reduce((sum, input) => sum + input, 0);
          var difference = 100 - totalSum;
          var indexToUpdate;

          if(totalSum > 100){
              indexToUpdate = inputVals.indexOf(currentMaxVal);
              if(indexToUpdate === currentInputIndex) {
                  indexToUpdate = inputVals.indexOf(currentMaxVal, 1);
              }
          } else if (totalSum < 100){
              indexToUpdate = inputVals.indexOf(currentMinVal);
              if(indexToUpdate === currentInputIndex) {
                  indexToUpdate = inputVals.indexOf(currentMinVal, 1);
              }
          }

          inputVals[indexToUpdate] += difference;
          var clampedValue = Math.max(5, Math.min(inputVals[indexToUpdate], maxVal));
          inputVals[indexToUpdate] = clampedValue;

          $inputs.each(function(i, el) {
              $(el).val(inputVals[i]).attr('value', inputVals[i]);
          });

          totalSum = inputVals.reduce((sum, input) => sum + input, 0);
          
          if(totalSum !== 100) {
              count++;
              if(count < 7) { // safeguard against infinite loop
                  adjustValues();
              }
          } else {
              updateColors();
          }
      }
  }    
  
  function toggleSwatches(){
      var $parent = $(this).closest('.blend-color');
      if($parent.hasClass('show-swatches')){
          $parent.removeClass('show-swatches');
      } else {
          $parent.addClass('show-swatches');
      }
  }

  // init
  var $type = 'advanced';
  var $shape = 'squares'; 
  var $first = 0;
  var $row = 6;
  var $grid = $row * $row;        
  
  $('.colors .swatch').click(selectColor);
  $('.add-set').click(addColor);
  $('.remove-set').click(removeColor); 
  $('.set input').on('change', updatePercentage);    
  $('.blend-color .toggle-swatches').click(toggleSwatches);
  $('#refresh-blends-preview').click(updatePreview);   
  
  updateSelectedVariant();
  squaressHeight();
  diamondsHeight(); 
  
  $(window).resize(function() {
      squaressHeight();
      diamondsHeight();    
  });
});